import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import type { RootState } from 'store';

import { RenewalStateProps } from './renewal.types';

export const initialState: RenewalStateProps = {
  anyQuestions: null,
  checkSideEffects: [],
  customCompound: null,
  dosagePreference: null,
  dosagePreferences: [],
  isMedicalHistoryChanged: null,
  lastDoseTaken: null,
  medicationEffect: null,
  medicationEffects: [],
  medicationNegativeReasons: [],
  mifResultIds: [],
  needAppointment: null,
  noticedSideEffects: null,
  rateYourEffect: [],
  weight: null
};

const renewalSlice = createSlice({
  initialState,
  name: 'renewal',
  reducers: {
    clearRenewal: () => initialState,
    setRenewal: (state, action: PayloadAction<Partial<RenewalStateProps>>) => {
      return { ...state, ...action.payload };
    }
  }
});

export const { clearRenewal, setRenewal } = renewalSlice.actions;

export const selectRenewalInfo = (state: RootState) => state.renewal;

export default renewalSlice.reducer;
